/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Payments_N_Refunds__Question_1Inputs */

const en_help_center__payments_n_refunds__question_1 = /** @type {(inputs: Help_Center__Payments_N_Refunds__Question_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are there any hidden fees?`)
};

/**
* | output |
* | --- |
* | "Are there any hidden fees?" |
*
* @param {Help_Center__Payments_N_Refunds__Question_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__payments_n_refunds__question_1 = /** @type {((inputs?: Help_Center__Payments_N_Refunds__Question_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Payments_N_Refunds__Question_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__payments_n_refunds__question_1(inputs)
});